import { ALL_LEAD_LIST_KEYS, DEFAULT_LEAD_LIST_KEY } from "@/constants/lead-lists.constants";
import { SettingListConfig } from "@/types/setting-list-config.types";

export const DEFAULT_SETTING_LIST_CONFIG: SettingListConfig = {
    selectedListKey: DEFAULT_LEAD_LIST_KEY,
    customLanguages: [],
    customLayouts: [],
    customStatuses: [],
};

const isRecord = (value: unknown): value is Record<string, unknown> => {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};

const parseStringArray = (value: unknown): string[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    return value.filter((item): item is string => typeof item === "string");
};

const parseOptionalInteger = (value: unknown): number | undefined => {
    if (typeof value === "number" && Number.isInteger(value)) {
        return value;
    }

    return undefined;
};

export const normalizeSettingListConfig = (value: unknown): SettingListConfig | null => {
    if (!isRecord(value)) {
        return null;
    }

    if (typeof value.selectedListKey !== "string") {
        return null;
    }

    return mergeSettingListConfig(DEFAULT_SETTING_LIST_CONFIG, {
        selectedListKey: value.selectedListKey,
        customLanguages: parseStringArray(value.customLanguages),
        customLayouts: parseStringArray(value.customLayouts),
        customStatuses: parseStringArray(value.customStatuses),
        customSettingPriorityMin: parseOptionalInteger(value.customSettingPriorityMin),
        customSettingPriorityMax: parseOptionalInteger(value.customSettingPriorityMax),
    });
};

export const mergeSettingListConfig = (
    current: SettingListConfig,
    patch: Partial<SettingListConfig>
): SettingListConfig => ({
    ...current,
    ...patch,
});

export const resolveSettingListConfig = (config: Record<string, unknown>): SettingListConfig => {
    return normalizeSettingListConfig(config.SETTING_LIST) ?? DEFAULT_SETTING_LIST_CONFIG;
};

export const resolveListsListKey = (listKey: string | undefined | null): string => {
    if (listKey && ALL_LEAD_LIST_KEYS.includes(listKey)) {
        return listKey;
    }

    return DEFAULT_LEAD_LIST_KEY;
};
